import { Actions as FetchFeatureFlagsActions } from './actions/fetchFeatureFlags';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IFeatureFlag } from '../../interfaces/featureFlag';

export type State = DeepReadonly<{
  isFetching: boolean;
  featureFlags: IFeatureFlag[];
  error: AxiosError | null;
}>;

export const initialState: State = {
  isFetching: false,
  featureFlags: [],
  error: null
};

export function reducer(state: State = initialState, action: FetchFeatureFlagsActions): State {
  switch (action.type) {
    case 'FETCH_FEATURE_FLAGS_REQUEST':
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case 'FETCH_FEATURE_FLAGS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        featureFlags: action.payload,
        error: null
      };
    case 'FETCH_FEATURE_FLAGS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
